<template>
  <li v-if="canViewVerticalNavMenuLink(item)" class="nav-item" :class="{
    'active': isActive,
    'disabled': item.disabled
  }">
    <b-link v-bind="linkProps" class="d-flex align-items-center">
      <IconOperationProgress v-if="item.title == 'Production Progress'" />
      <IconOrder v-else-if="item.title == 'Orders'" />
      <IconOEE v-else-if="item.title == 'OEE'" />
      <IconQuality v-else-if="item.title == 'Qualidade'" />
      <IconStops v-else-if="item.title == 'Paradas'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge v-if="item.tag" pill :variant="item.tagVariant || 'primary'" class="mr-1 ml-auto">
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'
import IconOperationProgress from '@/assets/images/pages/operation-progress-page-icon.svg'
import IconOrder from '@/assets/images/pages/order-page-icon.svg'
import IconOEE from '@/assets/images/pages/oee-icon.svg'
import IconQuality from '@/assets/images/pages/checklist-watch.svg'
import IconStops from '@/assets/images/pages/reload-watch-icon.svg'

export default {
  components: {
    BLink,
    BBadge,
    IconOperationProgress,
    IconOrder,
    IconOEE,
    IconQuality,
    IconStops
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
